import axios from '@/utils/axios.js'
import { encryptPassword } from '@/utils/rsa.js'

/**
 * 登录
 * @param {*} loginData 登录数据
 * @returns 登录信息
 */
export async function login(loginData) {
  const encryptedPassword = await encryptPassword(loginData.password)
  const { data } = await axios.post('/auth/login', { ...loginData, password: encryptedPassword })
  return data
}

/**
 * 注册
 * @param {*} registerData 注册数据
 * @returns 注册结果
 */
export async function register(registerData) {
  const encryptedPassword = await encryptPassword(registerData.password)
  const { data } = await axios.post('/auth/register', { ...registerData, password: encryptedPassword })
  return data
}

/**
 * 退出
 */
export async function logout() {
  await axios.post('/auth/logout')
}

/**
 * 获取登录用户角色信息
 * @returns 角色信息
 */
export async function getUserRole() {
  const { data } = await axios.get('/auth/thisRole')
  return data
}

/**
 * 发送邮箱验证码
 * @param {*} email 邮箱
 * @returns 发送结果
 */
export async function sendEmailCode(email) {
  const { data } = await axios.post('/auth/sendEmailCode', { email })
  return data
}

/**
 * 验证邮箱验证码
 * @param {*} params { email, code }
 * @returns 重置凭证
 */
export async function verifyCode(params) {
  const { data } = await axios.post('/auth/verifyCode', params)
  return data
}

/**
 * 重置密码
 * @param {*} params { code, newPassword }
 * @returns 重置结果
 */
export async function resetPassword(params) {
  const encryptedPassword = await encryptPassword(params.newPassword)
  const { data } = await axios.post('/auth/resetPassword', { ...params, newPassword: encryptedPassword })
  return data
}
